// extracted by mini-css-extract-plugin
export default {"TimelineImg":"Timeline_TimelineImg__2HPjD"};